var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RichText',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],attrs:{"blok":{ content: _vm.blok.content, classes: 'px-8 py-4' }}})}
var staticRenderFns = []

export { render, staticRenderFns }